<template>
  <div class="space-y-2">
    <BaseToggle v-model="active" :inderteminate="loading" :disabled="loading" />
    <BaseFormInlineMessage v-if="rejected" danger>
      {{ rejectReason }}
    </BaseFormInlineMessage>
  </div>
</template>

<script>
export default {
  props: {
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      rejected: false,
      rejectReason: 'something went wrong',
    };
  },
  computed: {
    active: {
      get() {
        return this.value;
      },
      set(value) {
        this.updateActive(value);
      },
    },
  },
  methods: {
    setLoading(value) {
      this.loading = Boolean(value);
    },
    async updateActive(active) {
      try {
        this.setLoading(true);
        await this.$store.dispatch('ui/thirdPartyServices/update', {
          id: this.thirdPartyServiceId,
          formData: { active },
        });
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
